module.exports = __webpack_public_path__ + "img/evaluatorblue.048e2405.svg";